module.exports = __webpack_public_path__ + "img/introduce-4.9d205275.png";